export type KeyMappings = {
    [parentKey: string]: string[];
};

/**
 * 
 * @param key used to determine which parent key to return
 * @param keyMappings mapping of parent keys to array of child routes
 * @returns the parent route key
 */
// we might need to use this in the future
export const getParentRouteKey = (key: string, keyMappings: KeyMappings): string => {
    // Iterate over the mappings to find the corresponding parent key
    for (const [parent, keys] of Object.entries(keyMappings)) {
        if (keys.includes(key)) {
            return parent;
        }
    }

    return 'hardware';
};